import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import { space } from 'styled-system';
import { Box } from '../Box/Box';
import { getPaletteColor } from '../utils/utils';
/**
 * @public
 */
export const InputGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "InputGroup",
  componentId: "sc-zgb0x6-0"
})(["display:flex;align-items:center;border-radius:", ";border-width:1px;border-style:solid;border-color:", ";& > ", "{width:100%;flex:1 1 auto;}& input{border:0;box-shadow:none;}", ""], themeGet('borderRadii.xl'), props => getPaletteColor(props.borderColor, 'base')(props), Box, space);
InputGroup.defaultProps = {
  borderColor: 'border'
};